<template>
  <div>
    <support-shortcut-modal
      v-model="visible"
      title="推广管理快捷键"
      size="600px"
      :mask-closable="true"
      @hide="onCancel"
    >
      <template slot="body">
        <div class="shortcut-table">
          <byted-table
            :columns="columns"
            :data="data"
            height="471"
          ></byted-table>
        </div>
      </template>
    </support-shortcut-modal>
  </div>
</template>

<script>
export default {
  name: 'promotion-keyboard-modal',

  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    onCancel: {
      type: Function,
      default: function () {}
    }
  },

  watch: {
    modalVisible: function (val) {
      this.visible = val
    }
  },

  data: function () {
    return {
      visible: false,
      columns: [
        {
          title: '快捷键',
          key: 'key',
          width: 140
        },
        {
          title: '使用说明',
          key: 'introduction'
        }
      ],
      data: [
        {
          key: window.$utils.isMac ? 'option + 1' : 'Alt + 1',
          introduction: '快速切换到广告组'
        },
        {
          key: window.$utils.isMac ? 'option + 2' : 'Alt + 2',
          introduction: '快速切换到广告计划'
        },
        {
          key: window.$utils.isMac ? 'option + 3' : 'Alt + 3',
          introduction: '快速切换到广告创意'
        },
        {
          key: window.$utils.isMac ? 'option + 4' : 'Alt + 4',
          introduction: '快速切换到关键词'
        },
        {
          key: '键盘左键',
          introduction: '当鼠标悬浮在表格滚动区时，水平向左滚动当前标签页中的表格'
        },
        {
          key: '键盘右键',
          introduction: '当鼠标悬浮在表格滚动区时，水平向右滚动当前标签页中的表格'
        },
        {
          key: window.$utils.isMac ? 'option + I' : 'Alt + I',
          introduction: '快速打开选中的广告组或广告计划详情（Information）'
        },
        {
          key: window.$utils.isMac ? 'option + R' : 'Alt + R',
          introduction: '快速打开选中的广告组或广告计划数据报告（Report）'
        },
        {
          key: window.$utils.isMac ? 'option + L' : 'Alt + L',
          introduction: '快速打开选中的广告组或广告计划日志（Log）'
        },
        {
          key: window.$utils.isMac ? 'option + D' : 'Alt + D',
          introduction: '快速打开选中的广告计划诊断（Diagnose）'
        },
        {
          key: window.$utils.isMac ? 'option + C' : 'Alt + C',
          introduction: '快速复制（Copy）选中的计划'
        },
        {
          key: window.$utils.isMac ? 'backspace' :'Backspace',
          introduction: '删除选中的广告组、计划和关键词'
        },
        {
          key: window.$utils.isMac ? 'option + N' : 'Alt + N',
          introduction: '在当前标签下新建（New）广告组、计划、创意和关键词'
        },
        {
          key: window.$utils.isMac ? 'option + E' : 'Alt + E',
          introduction: '编辑（Edit）当前选中的第一个广告组或计划'
        },
        {
          key: window.$utils.isMac ? 'option + shift + /' :'Alt + Shift + /',
          introduction: '显示快捷键说明'
        },
        {
          key: window.$utils.isMac ? 'shift + 点击' : 'Shift + 点击',
          introduction: '多选广告组、计划和关键词'
        },
        {
          key: window.$utils.isMac ? 'esc' : 'Esc',
          introduction: '关闭当前的弹窗'
        },
        {
          key: window.$utils.isMac ? 'enter' :'Enter',
          introduction: '确认，并继续下一步'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.shortcut-table {
  /deep/ {
    .byted-table table tr td .bui-table-ceil,
    .byted-table table tr th .bui-table-ceil {
      padding: 9px 16px !important;
    }
  }
}
</style>
